const baseOrigin = '//test.qubiankeji.com:8082';

export {
    baseOrigin
}
